import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.37 12.07l-10-4a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 .89.63H13a1 1 0 0 0 .9-.55l1.85-3.7 3.7-1.86a1 1 0 0 0-.08-1.82zm-4.82 2.03a1 1 0 0 0-.44.45l-1 2.01-2.31-5.77 5.76 2.31-2 1zM9 5a1 1 0 0 0 1-1V1a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1zM5 9a1 1 0 0 0-1-1H1a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1zm-.95-6.36a1 1 0 1 0-1.41 1.41l2.12 2.12a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41L4.05 2.64zm8.48 3.82a1 1 0 0 0 .71-.29l2.12-2.12a1 1 0 1 0-1.41-1.41l-2.12 2.12a1 1 0 0 0 .7 1.7zm-7.77 5.37l-2.12 2.12a1 1 0 1 0 1.41 1.41l2.12-2.12a1 1 0 1 0-1.41-1.41z"
});

var SvgBehaviorMajorMonotone = function SvgBehaviorMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgBehaviorMajorMonotone as S };
